import { Role } from '~/common/providers/auth/role';

export const uploadAllowedRoles: Role[] = ['LOGLASS_SYSTEM_ADMIN', 'TENANT_ADMIN', 'CORP_PLANNING'];
